module.exports = __webpack_public_path__ + "static/media/copy.13b7f511.svg";